(() => {
  'use strict';
  const dialog = document.getElementById('jonelia-saved');
  if (!dialog) return;
  const strings = JSON.parse(dialog.querySelector('[data-jon-saved-i18n]').textContent);
  const t = (key) => strings[key] || key;
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  const storageKey = 'jonelia:wishlist:v1';
  const maxItems = 100;
  const list = dialog.querySelector('[data-jon-saved-list]');
  const reorder = dialog.querySelector('[data-jon-reorder-content]');
  const status = dialog.querySelector('[data-jon-saved-status]');
  const toast = document.querySelector('[data-jon-saved-toast]');
  const money = new Intl.NumberFormat(dialog.dataset.locale, { style: 'currency', currency: dialog.dataset.currency });
  let memory = [];
  let persistent = true;
  let renderVersion = 0;
  let reorderVersion = 0;
  let toastTimer;
  let previousFocus;
  let cartBusy = false;
  let returnUrl = null;

  function readSaved() {
    try {
      const raw = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const seen = new Set();
      memory = Array.isArray(raw) ? raw.filter((item) => {
        if (!item || typeof item.handle !== 'string' || !item.handle.length || item.handle.length > 255 || /[/?#\\\s]/.test(item.handle) || ['.', '..'].includes(item.handle) || !/^\d+$/.test(String(item.variantId)) || seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      }).slice(0, maxItems).map((item) => ({ handle: item.handle, variantId: String(item.variantId), title: String(item.title || '').slice(0, 250) })) : [];
    } catch (_) {
      persistent = false;
    }
    return memory;
  }

  function writeSaved(items) {
    memory = items;
    try { localStorage.setItem(storageKey, JSON.stringify(items)); persistent = true; }
    catch (_) { persistent = false; }
    syncButtons();
  }

  function syncButtons() {
    document.querySelectorAll('[data-jon-saved-count]').forEach((count) => { count.textContent = String(memory.length); });
    document.querySelectorAll('[data-jon-save]').forEach((button) => {
      const saved = memory.find((item) => item.handle === button.dataset.handle);
      const active = !!saved && (button.dataset.mode !== 'variant' || saved.variantId === button.dataset.variantId);
      button.setAttribute('aria-pressed', String(active));
      const label = active ? t('remove') : t('save');
      button.setAttribute('aria-label', label + ': ' + button.dataset.productTitle);
      const text = button.querySelector('[data-jon-save-label]');
      if (text) text.textContent = active ? t('saved') : t('save');
    });
  }

  function notify(message, showLink = false) {
    if (dialog.open) status.textContent = message;
    else {
      toast.querySelector('span').textContent = message;
      toast.querySelector('button').hidden = !showLink;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 6000);
    }
  }

  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function productUrl(handle, variantId) {
    return root + 'products/' + encodeURIComponent(handle) + (variantId ? '?variant=' + encodeURIComponent(variantId) : '');
  }

  async function productData(handle) {
    const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' });
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(t('load_error'));
    return response.json();
  }

  function renderItem(saved, product, failed) {
    const article = node('article', 'jon-saved__item');
    article.dataset.jonItem = '';
    article.dataset.handle = saved.handle;
    article.dataset.variantId = saved.variantId;
    const variant = product?.variants?.find((item) => String(item.id) === saved.variantId);
    const url = productUrl(saved.handle, variant?.id);
    const picture = node('a', 'jon-saved__image');
    picture.href = url;
    picture.tabIndex = -1;
    picture.setAttribute('aria-hidden', 'true');
    const source = variant?.featured_image?.src || product?.featured_image;
    if (source) {
      const img = node('img');
      const imageUrl = new URL(source, location.origin);
      if (imageUrl.protocol === 'https:') { imageUrl.searchParams.set('width', '180'); img.src = imageUrl.href; }
      img.alt = ''; img.width = 88; img.height = 100; img.loading = 'lazy';
      picture.append(img);
    }
    const info = node('div', 'jon-saved__info');
    const title = node('h3');
    const link = node('a', '', product?.title || saved.title || t('product'));
    link.href = url; title.append(link); info.append(title);
    if (variant?.title && variant.title !== 'Default Title') info.append(node('p', 'jon-saved__variant', variant.title));
    if (variant) {
      const price = node('p', 'jon-saved__price', money.format(variant.price / 100));
      price.dataset.jonCurrentPrice = ''; info.append(price);
    }
    const actions = node('div', 'jon-saved__actions');
    if (variant?.available && !product.requires_selling_plan) {
      const add = node('button', 'jon-saved__button', t('add'));
      add.type = 'button'; add.dataset.jonAdd = '';
      actions.append(add);
    } else if (product?.requires_selling_plan) {
      const choose = node('a', 'jon-saved__text-link', t('choose_options'));
      choose.href = url; actions.append(choose);
    } else {
      info.append(node('p', 'jon-saved__availability', failed ? t('load_error') : t('unavailable')));
      if (product && !variant) {
        const choose = node('a', 'jon-saved__text-link', t('choose_options'));
        choose.href = productUrl(saved.handle); actions.append(choose);
      }
      if (failed) {
        const retry = node('button', 'jon-saved__text-link', t('retry'));
        retry.type = 'button'; retry.dataset.jonRetry = ''; actions.append(retry);
      }
    }
    const remove = node('button', 'jon-saved__remove', t('remove_short'));
    remove.type = 'button'; remove.dataset.jonRemove = saved.handle;
    remove.setAttribute('aria-label', t('remove') + ': ' + (product?.title || saved.title));
    actions.append(remove); info.append(actions); article.append(picture, info);
    return article;
  }

  async function renderWishlist() {
    const version = ++renderVersion;
    const items = [...memory];
    list.replaceChildren();
    list.removeAttribute('aria-busy');
    if (!items.length) {
      const empty = node('div', 'jon-saved__empty');
      empty.append(node('h3', '', t('empty_title')), node('p', '', t('empty_text')));
      const discover = node('a', 'jon-saved__button', t('discover'));
      discover.href = root + 'collections/jonelia-alle'; empty.append(discover); list.append(empty); return;
    }
    list.setAttribute('aria-busy', 'true');
    list.append(node('p', 'jon-saved__note', t('loading')));
    const results = new Array(items.length);
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(4, items.length) }, async () => {
      while (next < items.length && version === renderVersion) {
        const index = next++;
        try { results[index] = renderItem(items[index], await productData(items[index].handle), false); }
        catch (_) { results[index] = renderItem(items[index], null, true); }
      }
    }));
    if (version !== renderVersion) return;
    list.replaceChildren(...results.filter(Boolean));
    list.removeAttribute('aria-busy');
  }

  async function renderReorder() {
    const version = ++reorderVersion;
    reorder.setAttribute('aria-busy', 'true');
    reorder.replaceChildren(node('p', 'jon-saved__note', t('loading')));
    try {
      const url = new URL(root, location.origin);
      url.searchParams.set('section_id', 'jonelia-reorder');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error();
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fragment = parsed.querySelector('[data-jon-reorder-fragment]');
      if (!fragment) throw new Error();
      if (version === reorderVersion) reorder.replaceChildren(fragment);
    } catch (_) {
      if (version === reorderVersion) {
        reorder.replaceChildren(node('p', 'jon-saved__note', t('orders_error')));
        const retry = node('button', 'jon-saved__text-link', t('retry'));
        retry.type = 'button'; retry.dataset.jonReorderRetry = ''; reorder.append(retry);
      }
    } finally { if (version === reorderVersion) reorder.removeAttribute('aria-busy'); }
  }

  function activateTab(name, focus = false) {
    dialog.querySelectorAll('[data-jon-tab]').forEach((tab) => {
      const active = tab.dataset.jonTab === name;
      tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !active;
      if (active && focus) tab.focus();
    });
    status.textContent = '';
    if (name === 'reorder') renderReorder(); else renderWishlist();
  }

  function openDialog(name) {
    if (!dialog.open) {
      previousFocus = document.activeElement;
      if (!['#merkliste', '#wiederbestellen'].includes(location.hash)) returnUrl = location.href;
      dialog.showModal(); document.documentElement.classList.add('jon-saved-open');
    }
    toast.hidden = true;
    readSaved(); syncButtons(); activateTab(name);
  }

  async function addToCart(button) {
    if (cartBusy) return;
    const item = button.closest('[data-jon-item]');
    const input = item.querySelector('[data-jon-quantity]');
    const requestedQuantity = input ? Number(input.value) : 1;
    if (!Number.isSafeInteger(requestedQuantity) || requestedQuantity < 1) { notify(t('quantity_error')); input?.focus(); return; }
    cartBusy = true;
    const original = button.textContent;
    button.disabled = true; button.textContent = t('adding');
    status.textContent = '';
    try {
      const product = await productData(item.dataset.handle);
      const variant = product?.variants?.find((value) => String(value.id) === item.dataset.variantId);
      if (!variant?.available || product.requires_selling_plan) throw new Error(t('unavailable'));
      const rule = variant.quantity_rule || {};
      const quantity = input ? requestedQuantity : Math.max(1, rule.min || 1);
      if (quantity < (rule.min || 1) || (rule.max && quantity > rule.max) || quantity % (rule.increment || 1) !== 0) throw new Error(t('quantity_rule'));
      const price = item.querySelector('[data-jon-current-price]');
      if (price) price.textContent = money.format(variant.price / 100);
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : t('cart_error'));
      notify(t('added'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    } catch (error) { notify(error instanceof TypeError || error instanceof SyntaxError ? t('cart_error') : error.message || t('cart_error')); }
    finally { button.disabled = false; button.textContent = original; cartBusy = false; }
  }

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-jon-open]');
    if (open) { event.preventDefault(); event.stopPropagation(); openDialog(open.dataset.jonOpen); return; }
    const button = event.target.closest('[data-jon-save]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      readSaved();
      const existing = memory.find((item) => item.handle === button.dataset.handle);
      const remove = existing && (button.dataset.mode !== 'variant' || existing.variantId === button.dataset.variantId);
      if (!remove && !existing && memory.length >= maxItems) { notify(t('limit')); return; }
      const items = memory.filter((item) => item.handle !== button.dataset.handle);
      if (!remove) {
        if (!/^\d+$/.test(button.dataset.variantId)) { notify(t('choose_options')); return; }
        items.unshift({ handle: button.dataset.handle, variantId: button.dataset.variantId, title: button.dataset.productTitle });
      }
      writeSaved(items);
      notify(!persistent ? t('storage_error') : remove ? t('removed') : existing ? t('updated') : t('saved_message'), !remove);
    }
  }, true);

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-jon-saved-close]')) { dialog.close(); return; }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const tab = event.target.closest('[data-jon-tab]');
    if (tab) activateTab(tab.dataset.jonTab);
    const remove = event.target.closest('[data-jon-remove]');
    if (remove) {
      writeSaved(memory.filter((item) => item.handle !== remove.dataset.jonRemove));
      renderWishlist(); notify(t('removed')); document.getElementById('jon-panel-wishlist').focus();
    }
    if (event.target.closest('[data-jon-retry]')) renderWishlist();
    if (event.target.closest('[data-jon-reorder-retry]')) renderReorder();
    const add = event.target.closest('[data-jon-add]');
    if (add) addToCart(add);
  });

  dialog.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-jon-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const name = event.key === 'Home' ? 'wishlist' : event.key === 'End' ? 'reorder' : tab.dataset.jonTab === 'wishlist' ? 'reorder' : 'wishlist';
    activateTab(name, true);
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('jon-saved-open');
    if (['#merkliste', '#wiederbestellen'].includes(location.hash)) history.replaceState(history.state, '', returnUrl || location.pathname + location.search);
    previousFocus?.focus();
  });
  document.addEventListener('variant:changed', (event) => {
    const form = event.target.closest('form');
    if (!form) return;
    form.querySelectorAll('[data-jon-save][data-mode="variant"]').forEach((button) => { button.dataset.variantId = event.detail?.variant?.id ? String(event.detail.variant.id) : ''; });
    syncButtons();
  });
  let scheduled = false;
  new MutationObserver((records) => {
    if (scheduled || !records.some((record) => [...record.addedNodes].some((element) => element.nodeType === 1 && (element.matches?.('[data-jon-save]') || element.querySelector?.('[data-jon-save]'))))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; syncButtons(); });
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    readSaved(); syncButtons();
    if (dialog.open && !document.getElementById('jon-panel-wishlist').hidden) renderWishlist();
  });
  function openHash() {
    if (location.hash === '#merkliste') openDialog('wishlist');
    if (location.hash === '#wiederbestellen') openDialog('reorder');
  }
  window.addEventListener('hashchange', openHash);
  window.addEventListener('pageshow', () => { readSaved(); syncButtons(); });
  readSaved(); syncButtons(); openHash();
})();
